export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  livekitServerUrl: import.meta.env.VITE_LIVEKIT_URL,
};
